<template>
  <div class="lg-main">
    <!-- h5 welcome  -->
    <div class="h5-welcome"></div>
    <div class="container">
      <!-- h5  -->
      <div class="h5-title">Đăng Nhập</div>

      <div class="login">
        <!-- welcome  -->
        <div class="welcome"></div>

        <form>
          <!-- 账号 -->
          <div class="iptbox">
            <div class="item-icon icon-username"></div>
            <input
              v-model="loginForm.username"
              id="userName"
              type="text"
              placeholder="Tên đăng nhập"
              autocomplete="off"
              @blur="requiredVerification('username')"
            />
            <div class="iptbox-error" v-if="loginForm.usernameErrFlag">
              <img src="../assets/imgs/icon-alert.png" alt="" />
              <span>Tên tài khoản không được để trống</span>
            </div>
          </div>

          <!-- 密码 -->
          <div class="iptbox">
            <div class="item-icon icon-password"></div>
            <input
              v-model="loginForm.password"
              id="userPwd"
              :type="passwordType"
              placeholder="Mật khẩu"
              autocomplete="off"
              @blur="requiredVerification('password')"
            />
            <div class="icon-eyes">
              <div
                class="icon-hide"
                v-if="!showPsd"
                @click="
                  showPsd = true;
                  passwordType = 'text';
                "
              ></div>
              <div
                class="icon-show"
                v-else
                @click="
                  showPsd = false;
                  passwordType = 'password';
                "
              ></div>
            </div>
            <div class="iptbox-error" v-if="loginForm.passwordErrFlag">
              <img src="../assets/imgs/icon-alert.png" alt="" />
              <span>Nhập mật khẩu</span>
            </div>
          </div>

          <!-- 验证码 -->
          <div class="iptbox login-vaildCodeBox" v-if="needCaptcha">
            <div class="item-icon icon-captcha"></div>
            <input
              v-model="loginForm.captcha"
              type="text"
              id="loginVcode"
              placeholder="Mã xác nhận"
              autocomplete="off"
              @blur="requiredVerification('captcha')"
            />
            <div class="login-valid-code">
              <img class="imgCode" id="imgCode" :src="captchaImg" alt="" />
            </div>
            <div class="icon-reload" @click="getCaptchaFun"></div>
            <div class="iptbox-error" v-if="loginForm.captchaErrFlag">
              <img src="../assets/imgs/icon-alert.png" alt="" />
              <span>Nhập mã xác nhận</span>
            </div>
          </div>

          <div class="login_btn" @click="loginFun">Đăng nhập</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getCaptcha } from "@/api";
export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: "",
        usernameErrFlag: false,
        password: "",
        isShowPwd: false,
        passwordErrFlag: false,
        captcha: "",
        captchaErrFlag: false,
      },
      showPsd: false,
      passwordType: "password",
      needCaptcha: false,
      captchaImg: "",
    };
  },
  methods: {
    requiredVerification(properties) {
      if (!this.loginForm[properties] || this.loginForm[properties] == "") {
        this.$set(this.loginForm, `${properties}ErrFlag`, true);
      } else {
        this.$set(this.loginForm, `${properties}ErrFlag`, false);
      }
    },
    checkRequireds() {
      const { username, password, captcha } =
        this.loginForm;
      if (!username || !password) {
        if(!username) {
          this.$set(this.loginForm, 'usernameErrFlag', true);
        }
        if(!password) {
          this.$set(this.loginForm, 'passwordErrFlag', true);
        }
        return false;
      } else if (this.needCaptcha && !captcha) {
        this.$set(this.loginForm, 'captchaErrFlag', true);
        return false;
      }
    },
    getCaptchaFun() {
      getCaptcha().then((res) => {
        console.log(res);
        const { captcha } = res.data || {};
        this.captchaImg = captcha?.data?.url || "";
      });
    },
    loginFun() {
      let sentRequsetFlag = this.checkRequireds() == false ? false : true;
      console.log('sentRequsetFlag', sentRequsetFlag);
      if(!sentRequsetFlag) return;
      let params = {
        username: this.loginForm.username,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha,
      };
      login(params)
        .then((res) => {
          console.log(res.data);
          if(res.code == 1) {
            sessionStorage.setItem('login_status',1)
            window.location.href = '/'
          }
        
        })
        .catch((err) => {
          if(err.msg) {
            alert(err.msg);
          }else if (typeof JSON.parse(err.message) == "object") {
            const messageData = JSON.parse(err.message);
            const { data } = messageData;
            if (data.captcha) {
              this.needCaptcha = true;
            }
            if (messageData?.data?.captcha?.data?.url) {
              const { captcha } = data || {};
              this.captchaImg = captcha?.data?.url || "";
            }
            alert(messageData.msg);
          }
        });
    },
  },
};
</script>

<style>
@import url("../assets/css/reset-style.css");
.lg-main {
  min-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
}
.lg-main .container {
  margin: auto;
  background-image: linear-gradient(180deg, rgba(255,255,255,0.50) 0%, rgba(255,255,255,0.50) 30%);
  box-shadow: 0px 2px 6px 0px rgba(63,117,170,0.3);
}

.lg-main .login {
  overflow: hidden;
}

.lg-main .login .iptbox {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
}

.lg-main .login .iptbox input {
  flex: 1;
  box-sizing: border-box;
  color: #808897;
}

.lg-main .login .iptbox-error {
  position: absolute;
  left: 0;
  bottom: -20px;
  display: flex;
  align-items: center;
  height: 12px;
  color: #f65c5c;
  font-size: 12px;
}

.lg-main .login .iptbox-error img {
  margin-right: 3px;
  width: 12px;
  height: 12px;
}

.lg-main .login .login_btn {
  text-align: center;
  color: #ffffff;
  background-image: linear-gradient(180deg, #8bbcff 0%, #5387fd 100%);
  box-shadow: inset 0px -1px 1px 0px rgba(0, 54, 127, 0.58);
  box-shadow: inset 0px 1px 1px 0px rgba(255, 255, 255, 0.2);
  font-weight: 500;
}

.icon-username, .icon-password, .icon-captcha, .icon-reload {
  flex-shrink: 0;
}

.login-valid-code {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-vaildCodeBox input {
    min-width: 50px;
  }

@media screen and (min-width:481px) {
  .lg-main {
    background: url("../assets/imgs/bg-pc.png");
    background-size: cover;
  }
  .lg-main .container {
    margin: 196px auto;
    padding: 0 52px 60px 52px;
    max-width: 604px;
    width: 63%;
    border-radius: 40px;
  }

  .lg-main .welcome {
    margin: 77px auto 17px;
    width: 290px;
    height: 42px;
    background: url('../assets/imgs/welcome-pc.png') no-repeat center;
    background-size: cover;
  }

  .lg-main .login .iptbox {
    margin-top: 52px;
    padding: 1.9% 0;
    border-radius: 16px;
  }

  .lg-main .login .iptbox .item-icon {
    margin-left: 16px;
    width: 24px;
    height: 24px;
  }

  .icon-username {
    background: url("../assets/imgs/icon-username-pc.png") no-repeat center;
    background-size: cover;
  }

  .icon-password {
    background: url("../assets/imgs/icon-password-pc.png") no-repeat center;
    background-size: cover;
  }

  .icon-captcha {
    background: url("../assets/imgs/icon-captcha-pc.png") no-repeat center;
    background-size: cover;
  }

  .icon-reload {
    margin: 0 12px 0 16px;
    width: 20px;
    height: 20px;
    background: url("../assets/imgs/icon-refresh-pc.png") no-repeat center;
    background-size: cover;
  }

  .lg-main .login .iptbox input {
    padding-left: 8px;
    height: 32px;
    line-height: 32px;
    border-radius: 8.63px;
    font-size: 18px;
  }

  .lg-main .login .icon-eyes {
    margin-right: 16px;
  }
  .icon-hide {
    width: 24px;
    height: 24px;
    background: url("../assets/imgs/icon-hide-pc.png") no-repeat center;
    background-size: cover;
  }

  .icon-show {
    width: 24px;
    height: 24px;
    background: url("../assets/imgs/icon-show-pc.png") no-repeat center;
    background-size: cover;
  }

  .login-valid-code {
    flex-shrink: 0;
    width: 30%;
    max-width: 150px;

  }

  .lg-main .login .login_btn {
    margin-top: 52px;
    padding: 1.9% 0;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    font-size: 20px;
  }
  
  .lg-main .h5-welcome {
    display: none;
  }

  .lg-main .h5-title {
    display: none;
  }
}


@media screen and (max-width: 480px) {
  .lg-main {
    background: url("../assets/imgs/bg-m.png");
    background-size: cover;
  }

  .lg-main .h5-welcome {
    display: flex;
    justify-content: center;
    margin: 91px auto 35px;
  }

  .lg-main .container {
    margin-top: 0;
    box-sizing: border-box;
    padding: 0 7.5% 32px;
    width: 87.2%;
    border-radius: 20px;
    overflow: hidden;
  }

  .lg-main .login .iptbox {
    margin-top: 32px;
    border-radius: 8.63px;
  }

  .lg-main .login .iptbox .item-icon {
    margin-left: 12px;
    width: 14px;
    height: 14px;
  }

  .icon-username {
    background: url("../assets/imgs/icon-username-m.png") no-repeat center;
    background-size: cover;
  }

  .icon-password {
    background: url("../assets/imgs/icon-password-m.png") no-repeat center;
    background-size: cover;
  }

  .icon-captcha {
    background: url("../assets/imgs/icon-captcha-m.png") no-repeat center;
    background-size: cover;
  }

  .icon-reload {
    margin: 0 8px 0 12px;
    width: 12px;
    height: 12px;
    background: url("../assets/imgs/icon-refresh-m.png") no-repeat center;
    background-size: cover;
  }

  .lg-main .login .iptbox input {
    padding-left: 6px;
    height: 40px;
    border-radius: 8.63px;
    font-size: 12px;
  }

  .lg-main .login .icon-eyes {
    margin-right: 12px;
  }
  .icon-hide {
    width: 14px;
    height: 14px;
    background: url("../assets/imgs/icon-hide-m.png") no-repeat center;
    background-size: cover;
  }

  .icon-show {
    width: 14px;
    height: 14px;
    background: url("../assets/imgs/icon-show-m.png") no-repeat center;
    background-size: cover;
  }

  .login-valid-code {
    width: 80px;
  }

  .lg-main .login .welcome {
    display: none;
  }

  .lg-main .login .login_btn {
    margin-top: 32px;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    font-size: 12px;
  }

  .lg-main .h5-welcome {
    width: 193px;
    height: 28px;
    background: url("../assets/imgs/welcome-m.png") no-repeat center;
    background-size: cover;
  }

  .lg-main .h5-title {
    position: relative;
    display: block;
    margin: 24px 0 10px;
    line-height: 24px;
    color: #5387fd;
    font-size: 20px;
    font-weight: 700;
  }

  .lg-main .h5-title:after {
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 20px;
    height: 1px;
    border-radius: 4px;
    background: #5387fd;
    content: "";
  }
}
</style>
